import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import BankAccountPageUI from './BankAccountPageUI.js'

class BankAccountPageSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      account: null,
      bankAccountList: null,
      loanBankAccountNum: null,
      genBankAccountNum: null,
      bankAccountMonthList: null,
      createMode: false,
      transferMode: false,
      addBankAccountMode: false,
      addCollectionAccMode: false
    }
  }

  render() {
    return (
      <BankAccountPageUI
        context={this.props.context}
        account={this.state.account}
        bankAccountList={this.state.bankAccountList}
        loanBankAccountNum={this.state.loanBankAccountNum}
        genBankAccountNum={this.state.genBankAccountNum}
        bankAccountMonthList={this.state.bankAccountMonthList}
        onRefreshClick={this.onRefreshClick}
        //
        createMode={this.state.createMode}
        onCreateClick={() => { this.setState({ 'createMode': true }) }}
        onCancelCreateClick={() => { this.setState({ 'createMode': false }) }}
        //
        transferMode={this.state.transferMode}
        onTransferClick={() => { this.setState({ 'transferMode': true }) }}
        onCancelTransferClick={() => { this.setState({ 'transferMode': false }) }}
        bankAccountNumber={this.props.match.params.bankAccountId ||
          (this.state.bankAccountList && this.state.bankAccountList.length ? this.state.bankAccountList[0].bankAccountNumber : null)}
        onAddBankAccountClick={() => { this.setState({ 'addBankAccountMode': true }) }}
        addBankAccountMode={this.state.addBankAccountMode}
        onCancelAddBankAccount={() => { this.setState({ 'addBankAccountMode': false }) }}
        //
        addCollectionAccMode={this.state.addCollectionAccMode}
        onAddCollectionAccClick={() => { this.setState({ addCollectionAccMode: true }) }}
        onAddCollectionAccCancel={() => { this.setState({ addCollectionAccMode: false }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getAccounts(context)
    this.getBankAccounts(context)
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.bankAccountId == this.props.match.params.bankAccountId)
      return

    let context = this.props.context
    this.getBankAccounts(context)
  }

  getBankAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/bankAccounts`,
      cacheKey: CacheKeys.BankAccounts2(this.props.match.params.accountId),
      callback: this.getBankAccountsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBankAccountsCallback = (response) => {
    this.setState(
      {
        bankAccountList: response.bankAccountList,
        errorList: response.errorList
      }, () => {
        let bankAccountNumber = this.props.match.params.bankAccountId ||
          (response.bankAccountList.length ? response.bankAccountList[0].bankAccountNumber : null)
        if (bankAccountNumber)
          this.getBankAccountMonths(this.props.context, bankAccountNumber)
      }
    )

    let loanAcc = response.bankAccountList.filter(ba => ba.purpose === 'loan')
    let genAcc = response.bankAccountList.filter(ba => ba.purpose === 'general')
    if (loanAcc.length > 0 && genAcc.length > 0) {
      this.setState({
        loanBankAccountNum: loanAcc[0].bankAccountNumber,
        genBankAccountNum: genAcc[0].bankAccountNumber
      })
    }
    else if (genAcc.length > 0) {
      this.setState({
        genBankAccountNum: genAcc[0].bankAccountNumber,
      })
    }
  }

  getBankAccountMonths(context, bankAccountNumber) {
    let cacheManager = new CacheManager({
      resource: `/api/su/bankAccounts/${bankAccountNumber}/months`,
      cacheKey: CacheKeys.BankAccountMonths(bankAccountNumber),
      callback: this.getBankAccountMonthsCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getBankAccountMonthsCallback = (response) => {
    this.setState({ bankAccountMonthList: response.bankAccountMonthList })
  }

  getAccounts(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}`,
      cacheKey: CacheKeys.Accounts(this.props.match.params.accountId),
      callback: this.getAccountsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(context)
  }

  getAccountsCallback = (response) => {
    this.setState({ account: response.account })
  }

  onRefreshClick = () => {
    let context = this.props.context
    CacheManager.removeObject(CacheKeys.BankAccountMonths(this.props.match.params.bankAccountId))
    CacheManager.removeObject(CacheKeys.BankAccounts2(this.props.match.params.accountId))
    CacheManager.removeObject(CacheKeys.Accounts(this.props.match.params.accountId))

    this.setState({
      bankAccountList: null,
      bankAccountMonthList: null,
      account: null
    }, () => {
      this.getBankAccounts(context)
      this.getAccounts(context)
    })
  }
}

export default withRouter(BankAccountPageSF)
